export default __webpack_public_path__ + "static/1271-796bbba35f8e0c807f8173041e681fbb.png";